import { css } from '@emotion/react'
import { mediaQuery, typo } from '@mathflat/common/style'
import colors from '@mathflat/common/style/colors'

const S = {
  header: css`
    width: 100%;
    border-bottom: 1px solid ${colors.borderColor};
    position: relative;

    .header-container {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60px;
      max-width: 1920px;
      margin: 0 auto;
      padding: 0 24px;

      ${mediaQuery.medium} {
        width: 100%;
      }
    }
    .header-container-left,
    .header-container-right {
      display: flex;
      align-items: center;
      flex: 1;
    }

    .header-container-left {
      gap: 24px;
    }

    .header-container-right {
      height: 100%;
    }
    .header-school-exam-zone-badge {
      cursor: pointer;
      border: 1px solid var(--Colors-Orange-300);
      margin: 8px;

      &:hover {
        background-color: var(--Colors-Orange-200);
      }
      &.active {
        border-radius: 4px;
        border: 1px solid var(--Colors-Orange-400);
        background: var(--Colors-Orange-300);
        color: var(--Colors-Orange-600);
      }
    }
    .nav-link {
      display: flex;
      gap: 40px;
      height: 100%;
    }

    .nav-link__daily-learning {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .nav-link__daily-learning-beta {
      ${typo.caption01}
      display: inline-block;
      background: linear-gradient(90deg, var(--Colors-Sky-400) 0%, var(--Colors-Blue-600) 100%);
      color: transparent;
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: 700;
    }

    &.schoolflat {
      ${mediaQuery.mediumLarge} {
        .nav-link {
          gap: 60px;
        }
      }
    }
  `,
}

export default S
